import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GET_CUSTOMER_REPORT_DATA } from "../../configs/apiConfig";
import { ICustomerReportData } from "../../typings/interfaces/responses/customer-report-data-response";

export interface GetReportDataPayload {
    customerId: number;
    reportType: string;
    periodStart?: Date | null;
    periodEnd?: Date | null;
    billIds?: number[];
}

export const getCustomerReportDataAction = createAsyncThunk(
    "customer/getReportData",
    async (payload: GetReportDataPayload, { rejectWithValue }) => {
        try {
            const url = GET_CUSTOMER_REPORT_DATA(
                payload.customerId,
                payload.reportType,
                payload.periodStart?.toISOString(),
                payload.periodEnd?.toISOString(),
                payload.billIds
            );
            const response = await axios.get<{ body: ICustomerReportData }>(url);
            return response.data.body;
        } catch (err: any) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);
